export function TooltipCircle({ color }) {
  // renders a circle with the specified color
  const markerStyle = {
    borderRadius: '10px',
    width: '10px',
    height: '10px',
    backgroundColor: color,
  }

  return <div style={markerStyle} />
}
